<template>
  <div class="upload_wrap">
    <div class="upload_header">
      <div class="upload_header_left">
        <el-input
          :placeholder="'请输入' + searchTitle[uploadType] + '名称'"
          v-model="searchkeys"
          class="search_input"
        ></el-input>
        <el-button type="primary" @click="searchList">搜索</el-button>
        <span style="color:red;margin-left:12px;font-size:12px" v-if="uploadType !== 'img'">音视频时长需大于1分钟</span>
      </div>
      <div class="upload_header_right">
        <el-button
          type="danger"
          plain
          @click="delteList"
          :disabled="isDelDisabled"
          v-if="isUploadFlag"
          >删除</el-button
        >
        <el-button type="primary" plain @click="uploadLocal" v-else>
          <i class="iconfont">&#xe60f;</i>
          <span style="margin-left: 6px"
            >选择本地{{ searchTitle[uploadType] }}</span
          >
        </el-button>
      </div>
    </div>
    <div class="uploadList" ref="uploadList">
      <upload-file
        class="upload_file"
        ref="uploadFile"
        @change="changeFile"
        :accept="accept"
        :uploadType="uploadType"
        @isFinsh="isFinsh"
        :multiple="multiple"
        :class="'upload_file_' + uploadType"
        :style="{ width: listW, height: listH }"
        :uploadSize="uploadSize"
        :isAddSucaiFlag="isAddSucaiFlag"
        v-if="isUploadFlag"
      >
        <div slot="upload_con" class="upload_con" @click="uploadFiles">
          <i class="iconfont">&#xe60f;</i>
          <p>{{ uploadTitle }}</p>
        </div>
      </upload-file>
      <upload-item
        v-for="(item, index) in uploadList"
        :key="'uploadList' + index"
        :item="item"
        :isUploadFlag="isUploadFlag"
        :width="listW"
        :height="listH"
        @changeChecked="
          changeChecked($event, item, 'audio_uploadList_process' + index)
        "
        class="uploadList_li"
      >
        <div
          slot="uploadItem_top"
          class="uploadItem_top"
          :class="'upload_' + uploadType"
        >
          <template v-if="item.url">
            <div class="img" v-if="uploadType == 'video'">
              <img :src="isAliOSSFlag(item.url)" alt="" />
            </div>
            <div v-else-if="uploadType == 'audio'" class="img">
              <audio
                :src="item.url"
                controls
                style="display: none"
                :ref="'uploadList_audio' + index"
                @timeupdate="
                  timeupdate($event, item, 'uploadList_audio' + index)
                "
                @ended="ended($event, item)"
              ></audio>
              <p @click.stop="play(item, 'uploadList_audio' + index)">
                <i class="iconfont" v-if="item.paused" style="font-size: 16px"
                  >&#xe65a;</i
                >
                <i class="iconfont" v-else>&#xe653;</i>
              </p>
              <div
                class="play_process"
                :ref="'audio_uploadList_process' + index"
              >
                <div @mousedown="isDraging = true" @mouseup="isDraging = false">
                  <el-slider
                    v-model="item.audioValue"
                    class="audio_process"
                    :min="0"
                    :max="item.duration"
                    height="4"
                    @change="
                      (value) => {
                        changeAudio(value, item, 'uploadList_audio' + index);
                      }
                    "
                    :format-tooltip="formatTooltip"
                  ></el-slider>
                </div>
                <div class="playTime">
                  <span>{{ item.audioValue | handleDuration }}</span>
                  <span>{{ item.duration | handleDuration }}</span>
                </div>
              </div>
            </div>
            <div v-else class="img">
              <el-image
                class="sourse-img"
                :src="item.url"
                :ref="'uploadList-img' + index"
                :preview-src-list="srcList"
                :z-index="zIndex"
              >
              </el-image>
            </div>
          </template>
          <div v-else class="process">
            <div class="process_con">
              <el-progress
                :percentage="item.process"
                style="width: 80%"
                :show-text="false"
                :color="item.type == 'error' ? 'red' : '#4e70f2'"
              ></el-progress>
              <i
                class="iconfont"
                @click="reloadFile(item, index)"
                v-if="item.type == 'error'"
                >&#xe620;</i
              >
            </div>
            <p>{{ item.process }}%</p>
            <i
              class="iconfont del_process"
              v-if="item.type == 'error'"
              @click="delUpload(index)"
              >&#xe615;</i
            >
          </div>
          <p
            :class="'btn_' + uploadType"
            class="btn_oper"
            @click.stop="preview(item, 'uploadList-img' + index)"
            v-if="btnTitle && item.url"
          >
            {{ btnTitle }}
          </p>
        </div>
      </upload-item>
      <upload-item
        v-for="(item, index) in fileList"
        :key="'fileList' + index"
        :item="item"
        :width="listW"
        :isUploadFlag="isUploadFlag"
        :height="listH"
        :disabledFun="disabledFun"
        @changeChecked="
          changeChecked($event, item, 'audio_fileList_process' + index)
        "
        @editName="editName(item)"
        class="uploadList_li"
      >
        <div
          slot="uploadItem_top"
          class="uploadItem_top"
          :class="'upload_' + uploadType"
        >
          <div class="img" v-if="uploadType == 'video'">
            <img :src="isAliOSSFlag(item.url)" alt="" />
          </div>
          <div v-else-if="uploadType == 'audio'" class="img">
            <audio
              :src="item.url"
              controls
              style="display: none"
              :ref="'fileList_audio' + index"
              @timeupdate="timeupdate($event, item, 'fileList_audio' + index)"
              @ended="ended($event, item)"
            ></audio>
            <p @click.stop="play(item, 'fileList_audio' + index)">
              <i class="iconfont" v-if="item.paused" style="font-size: 16px"
                >&#xe65a;</i
              >
              <i class="iconfont" v-else>&#xe653;</i>
            </p>
            <div class="play_process" :ref="'audio_fileList_process' + index">
              <div @mousedown="isDraging = true" @mouseup="isDraging = false">
                <el-slider
                  v-model="item.audioValue"
                  class="audio_process"
                  :min="0"
                  :max="item.duration"
                  height="4"
                  @change="
                    (value) => {
                      changeAudio(value, item, 'fileList_audio' + index);
                    }
                  "
                  :format-tooltip="formatTooltip"
                ></el-slider>
              </div>
              <div class="playTime">
                <span>{{ item.audioValue | handleDuration }}</span>
                <span>{{ item.duration | handleDuration }}</span>
              </div>
            </div>
          </div>
          <div v-else class="img">
            <el-image
              :ref="'fileList-img' + index"
              class="sourse-img"
              :src="item.url"
              :preview-src-list="srcList"
              :z-index="zIndex"
            >
            </el-image>
          </div>
          <p
            :class="'btn_' + uploadType"
            class="btn_oper"
            @click.stop="preview(item, 'fileList-img' + index)"
            v-if="btnTitle"
          >
            {{ btnTitle }}
          </p>
        </div>
      </upload-item>
      <template v-if="isShowList">
        <div
          v-for="item in listNum"
          :key="item"
          style="height: 0; flex-shrink: 0"
          :style="{ width: listW }"
        ></div>
      </template>
      <el-dialog
        title=""
        append-to-body
        :visible.sync="videoFlag"
        width="50%"
        v-if="videoFlag"
      >
        <video  id="my-player" class="video-js" preload="auto" data-setup='{}' controls autoplay style="max-height: 70vh;width: 100%; margin: 0 auto; display: block" ref="previewVideo">
						<source :src="previewObj.url"></source>
					</video>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import uploadItem from "./uploadItem.vue";
import uploadFile from "../newUpload/upload.vue";
import { mapActions } from "vuex";
import { getAliFileUploadUrl } from '@/utils/baseUrl.js'
import videojs from "video.js"
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    uploadType: {
      type: String,
      default: "video",
    },
    uploadTitle: {
      type: String,
      default: "点击上传本地视频",
    },
    btnTitle: {
      type: String,
      default: "播放",
    },
    accept: {
      type: Array,
      default: () => ['.mp4','.mov'],
    },
    addNumber: {
      type: Number,
      default: 1,
    },
    listW: {
      type: String,
      default: "240px",
    },
    listH: {
      type: String,
      default: "185px",
    },
    rowNum: {
      type: Number,
      default: 4,
    },
    isUploadFlag: {
      type: Boolean,
      default: true,
    },
    uploadSize: {
      type: String,
      default: "300mb",
    },
    isAddSucaiFlag: {
        type: Boolean,
        default: true
    },
    iscustomFlag: {
      type: Boolean,
      default: false
    },
    disabledFun: {
      type: Function,
      default: () => false
    }
  },
  inject: {
    parent: {
      default: () => {}
    }
  },
  data() {
    return {
      fileList: [],
      uploadList: [],
      videoFlag: false,
      previewObj: {},
      audioValue: 0,
      isDraging: false,
      srcList: [],
      searchTitle: {
        video: "视频",
        audio: "音频",
        img: "图片",
      },
      searchkeys: "",
      isFinshFlag: false,
      zIndex: 3000
    };
  },
  components: {
    "upload-item": uploadItem,
    "upload-file": uploadFile,
  },
  computed: {
    isShowList() {
      let uploadList = JSON.parse(JSON.stringify(this.uploadList));
      let fileList = this.fileList;
      let addNumber = this.addNumber;
      return (
        (uploadList.length || fileList.length) &&
        (uploadList.length + fileList.length + addNumber) % this.rowNum != 0
      );
    },
    listNum() {
      let uploadList = JSON.parse(JSON.stringify(this.uploadList));
      let fileList = this.fileList;
      let addNumber = this.addNumber;
      return (
        this.rowNum -
        ((uploadList.length + fileList.length + addNumber) % this.rowNum)
      );
    },
    isDelDisabled() {
      // console.log(this.fileList, this.uploadList)
      let fileList = this.fileList.filter(item => item.checked)
      let uploadList = this.uploadList.filter(item => item.checked)
      console.log(fileList, uploadList)
      return !fileList.length && !uploadList.length;
    },
    isAliOSSFlag() {
      return (url) => {
		  let str = '?'
		  if(url.includes('timestamp=')){
			  str = '&'
		  }
        return url.includes(getAliFileUploadUrl().video.domain) ?url + str+'x-oss-process=video/snapshot,t_1000,f_jpg' : url + str+'vframe/jpg/offset/1'
      }
    }
  },
  methods: {
    ...mapActions("uploads", ["materialRemove", "materialEditName"]),
    changeChecked(e, item, name) {
      if (this.uploadType === "audio") {
        let dom = this.$refs[name][0];
        if (dom.contains(e.target)) {
          return;
        }
      }
      if (this.uploadType == "img") {
        this.srcList = [];
      }
      let list = [...this.uploadList, ...this.fileList];
      if (this.multiple) {
        this.$set(item, "checked", !item.checked);
      } else {
        list.forEach((item) => {
          this.$set(item, "checked", false);
        });
        if (!item.checked) {
          this.$set(item, "checked", true);
        }
      }
      this.$emit(
        "select",
        list.filter((item) => item.checked)
      );
    },
    uploadFiles() {
      this.$refs.uploadFile.uploadFile();
    },
    changeFile(list) {
      this.uploadList = list;
    },
    preview(item, name) {
      if (this.uploadType == "video") {
        this.previewObj = item;
        this.videoFlag = true;
        this.$nextTick(() => {
          this.initVideo()
        })
      } else {
        this.srcList = [item.url];
        let doms = this.$refs[name][0];
        try {
          let modalDom = document.querySelector('.v-modal')
          if(modalDom) {
            let zIndexModal = modalDom.style.zIndex
            this.zIndex = zIndexModal ? zIndexModal*1 + 100 :  this.zIndex
          }
        } catch (error) {
          this.zIndex = 10000
        }
        setTimeout(() => {
          doms.clickHandler();
        }, 0);
      }
    },
    play(item, name) {
      let audioDom = this.$refs[name][0];
      if (audioDom.paused) {
        item.audioValue && item.audioValue > 0
          ? (audioDom.currentTime = item.audioValue)
          : "";
        this.$set(item, "paused", true);
        audioDom.play();
      } else {
        audioDom.pause();
        this.$set(item, "paused", false);
      }
    },
    changeAudio(value, item, name) {
      let audioDom = this.$refs[name][0];
      audioDom.currentTime = value;
      // this.$set(item, 'audioValue', value)
      // console.log(e, ea,'ppp')
    },
    formatTooltip(value) {
      return this.$options.filters["handleDuration"](value);
    },
    timeupdate(e, item, dom) {
      if (!this.isDraging) {
        this.$set(item, "audioValue", Math.floor(e.target.currentTime));
      }
      // console.log(e.target.currentTime, 'pppp')
    },
    ended(e, item) {
      this.$set(item, "paused", false);
      this.$set(item, "audioValue", 0);
    },
    delteList() {
      if (!this.isFinshFlag && this.$refs.uploadFile.uploadList.length) {
        this.$message({
          type: "error",
          message: `请等待当前${
            this.searchTitle[this.uploadType]
          }上传完毕,再做删除操作！`,
        });
        return;
      }
      let fileList = this.fileList.filter((item) => item.checked);
      this.$confirm(
        `确定要删除当前选中的${fileList.length}个${
          this.searchTitle[this.uploadType]
        }吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        let idList = fileList.map((item) => item.id);
        try {
         await this.materialRemove({
            ids: idList.join(","),
          });
          this.$emit("uploadFinsh");
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 3000,
          });
        } catch (error) {}
      });

      // console.log(idList,'....fileList')
    },
    reloadFile(item, i) {
      // console.log(item)
      this.$refs.uploadFile.reloadFile(item, i);
    },
    delUpload(index) {
      this.uploadList.splice(index, 1);
    },
    searchList() {
      this.$emit("search", this.searchkeys);
    },
    isFinsh(value) {
      if (value) {
        this.$refs.uploadFile.uploadList = [];
        this.$emit("uploadFinsh");
      }
    },
    editName(item) {
      let name = item.name.slice(0, item.name.lastIndexOf("."));
      let suffix = item.name.slice(
        item.name.lastIndexOf("."),
        item.name.length
      );
      this.$msgbox({
        title: "消息",
        showInput: true,
        inputValue: name,
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        try {
          await this.materialEditName({
            id: item.id,
            name: value + suffix,
          });
          this.$set(item, "name", value + suffix);
          this.$message({
            type: "success",
            message: "修改成功",
            duration: 3000,
          });
        } catch (error) {
          console.log(error, "oo");
        }
        console.log(value);
      });
    },
    uploadLocal() {
      if(!this.iscustomFlag) {
        this.parent.sucaiDialogUpload()
      } else {
        this.$emit('uploadLocal')
      }
      // console.log(this.parent, 'oooo')
    },
    initVideo(){
      const player = videojs(this.$refs.previewVideo,{
        bigPlayButton: true, 
        posterImage: false,
        errorDisplay: false,
        //设置小喇叭音量键
        controlBar: {
          fullscreenToggle: true,
          // 音量条的横向还是纵向显示
          volumePanel: {
          inline: false,
          },
        },
        muted: false // //静音模式   解决首次页面加载播放。
      })
      console.log(player, '===player')
    }
  },
  filters: {
    handleDuration(value) {
      if (Number(value).toString() !== "NaN") {
        let h = Math.floor((value / 3600) % 24)
          .toString()
          .padStart(2, 0);
        let m = Math.floor((value / 60) % 60)
          .toString()
          .padStart(2, 0);
        let s = (value % 60).toString().padStart(2, 0);
        return h + ":" + m + ":" + s;
      } else {
        return "00:00:00";
      }
    },
  },
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler(news) {
        this.fileList = JSON.parse(JSON.stringify(news));
      },
    },
  },
};
</script>
<style lang="less">
.audio_process {
  .el-slider__button {
    width: 10px;
    height: 10px;
  }
  .el-slider__button-wrapper {
    top: -16px;
  }
  .el-slider__runway {
    height: 4px;
  }
}
.sourse-img {
  width: 100%;
  height: 100%;
  .el-image__inner {
    object-fit: cover !important;
    vertical-align: top;
  }
}
</style>
<style lang="less" scoped>
.upload_wrap {
  .upload_header {
    display: flex;
    justify-content: space-between;
    .search_input {
      width: 240px;
      margin-right: 10px;
    }
  }
}
.uploadList {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}
.upload_video {
  width: 100%;
  height: 100%;
}
.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  position: relative;
  .del_process {
    position: absolute;
    right: 12px;
    top: 12px;
    color: red;
    font-size: 14px;
    cursor: pointer;
  }
  .process_con {
    width: 100%;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      margin-left: 6px;
      color: red;
      cursor: pointer;
    }
  }
}
.upload_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  .iconfont {
    color: #4e70f2;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 10px;
  }
  p {
    color: #4e70f2;
  }
}
.uploadItem_top {
  width: 100%;
  height: 100%;
  .img {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 1;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      vertical-align: top;
    }
  }
}
.uploadList_li {
  margin-bottom: 20px;
  // margin-left: 20px;
}
.upload_file {
  background: #f3f4f9;
  border-radius: 4px;
  border: 1px solid #e3e5ee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #4e70f2;
  font-size: 14px;
  box-sizing: border-box;
  &.upload_file_img {
    width: 180px;
    height: 290px;
  }
}
.btn_oper {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 8px 15px;
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 8px;
  left: 8px;
  border-radius: 30px;
  cursor: pointer;
  transform: translateY(calc(100% + 8px));
  transition: all 0.2s;
  z-index: 9;
}
.uploadItem_top_con:hover {
  .btn_oper {
    transform: translateY(0);
  }
}
.upload_audio {
  background-color: #f3f4f9;
  .img {
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    .play_process {
      flex: 1;
      width: 0;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      .playTime {
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 12px;
      }
    }
    p {
      width: 32px;
      height: 32px;
      background: #4e70f2;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .iconfont {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
</style>
